import { render, staticRenderFns } from "./SuccessVerif.vue?vue&type=template&id=f5ada5c0&"
import script from "./SuccessVerif.vue?vue&type=script&lang=js&"
export * from "./SuccessVerif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports